<div class="d-flex align-items-center h-full mat-bg-default">
  <div class="app-error">
    <div class="fix">
      <mat-icon class="error-icon" color="warn">error</mat-icon>
      <div class="error-text">
        <h1 class="error-title">404</h1>
        <div class="error-subtitle">Page Not Found!</div>
      </div>
    </div>
    
    <div class="error-actions">
      <button 
      mat-raised-button 
      color="primary"
      class="mb-16 mr-8"
      [routerLink]="['/']">Back to Dashboard</button>
      
      <button 
      mat-raised-button 
      color="warn">Report this Problem</button>
    </div>
  </div>
</div>
